// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  AppearEffectEnum,
  VoucherIconListEnum,
  TemplateStructureEnum,
  ComponentNameEnum,
  ElementPartTypeEnum,
} from '@/types';
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import {
  setAnimated,
  setClass,
  setVoucherIconClass,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getClassByName,
  getText,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import {
  restoreVoucherButtons,
  switchVoucherButtonsAndCodes,
  toggleDesignPanel,
} from '@/components/template-builder/callbacks';

// eslint-disable-next-line import/no-cycle
import setText from '@/components/template-builder/setters/voucher';
// eslint-disable-next-line import/no-cycle
import getInputVariablesFieldConfig from '@/components/template-builder/config/fields/input-variables-config';
// eslint-disable-next-line import/no-cycle
import getDropdownFieldConfig from '@/components/template-builder/config/fields/dropdown-config';
// eslint-disable-next-line import/no-cycle
import getIconsFieldConfig from '@/components/template-builder/config/fields/icons-config';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import getTriggerButtonFieldConfig from '@/components/template-builder/config/fields/trigger-button-config';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const widgetVoucherConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.voucher',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        onTabUnmount: () => {
          restoreVoucherButtons();
        },
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.buttonConfiguration',
              selector: 'body #spm_body #{ID}',
              onTabActivate: () => {
                switchVoucherButtonsAndCodes();
              },
              items: [
                {
                  label: 'templateBuilder.fields.buttonText',
                  selector: '{SELECTOR} .spm_container_voucher_button a.spm_button',
                  properties: [{ name: 'content', getter: getText, setters: [setText] }],
                  ...getInputVariablesFieldConfig('Texte du bouton', variables.allVariables, false, true),
                },
                {
                  label: 'templateBuilder.fields.appearEffect',
                  selector: '{SELECTOR} .spm_container_voucher_button',
                  properties: [{ name: 'spmEffect_', getter: getClassByName, setters: [setClass, setAnimated] }],
                  ...getDropdownFieldConfig(Object.values(AppearEffectEnum).map((effect) => ({ label: effect, value: effect })), AppearEffectEnum.NONE),
                },
                {
                  label: 'templateBuilder.fields.voucherIcon',
                  selector: '{SELECTOR} .spm_container_voucher_button .spm_voucher_icon',
                  properties: [{ name: 'spm_icon-', getter: getClassByName, setters: [setVoucherIconClass] }],
                  ...getIconsFieldConfig(Object.values(VoucherIconListEnum), 'spm_icon-', 'hidden'),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.codeConfiguration',
              selector: 'body #spm_body #{ID}',
              onTabActivate: () => {
                switchVoucherButtonsAndCodes();
              },
              items: [
                {
                  label: 'templateBuilder.fields.appearEffect',
                  selector: '{SELECTOR} .spm_container_voucher_code',
                  properties: [{ name: 'spmEffect_', getter: getClassByName, setters: [setClass, setAnimated] }],
                  ...getDropdownFieldConfig(Object.values(AppearEffectEnum).map((effect) => ({ label: effect, value: effect })), AppearEffectEnum.NONE),
                },
                {
                  label: 'templateBuilder.fields.voucherIcon',
                  selector: '{SELECTOR} .spm_container_voucher_code .spm_voucher_icon_code',
                  properties: [{ name: 'spm_icon-', getter: getClassByName, setters: [setClass] }],
                  ...getIconsFieldConfig(Object.values(VoucherIconListEnum), 'spm_icon-', 'hidden'),
                },

              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: '',
              items: [
                {
                  label: 'templateBuilder.formFields.stylesInGlobalVoucherConfig',
                  selector: '',
                  properties: [],
                  componentName: ComponentNameEnum.INFORMATION,
                  options: {
                    severity: 'secondary',
                  },
                },
                {
                  label: 'templateBuilder.formFields.goToGlobalFormStyles',
                  selector: '',
                  properties: [],
                  ...getTriggerButtonFieldConfig(
                    'templateBuilder.formFields.goToGlobalFormStyles',
                    'templateBuilder.formFields.goToGlobalFormStyles',
                    () => toggleDesignPanel('pageInputs'),
                  ),
                },
              ],
            },
            getWidgetCommonStylesGroup(),
          ],
        },
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
    ],
  },
};

export default widgetVoucherConfig;
